export const SIGN_IN_PAGE: string = "My Account:Login";
export const ACCOUNT_CREATION_PAGE: string = "My Account:Account Creation";
export const PASSWORD_RESET_PAGE: string = "My Account:Password Reset";
export const MULTIPLE_ACCOUNT_FOUND_PAGE: string = "My Account:Multiple Accounts Notification";

export const SIGN_IN_ATTEMPT: string = "User Sign-In Attempted";
export const SIGN_IN_SUCCESS: string = "User Sign-In Succeeded";
export const ACCOUNT_CREATION_ATTEMPT: string = "User Account Creation Attempted";
export const ACCOUNT_CREATION_SUCCESS: string = "User Account Created";
export const PASSWORD_RESET_ATTEMPT: string = "Reset-Password Attempted";
export const MULTIPLE_ACCOUNT_SYNC_REQUESTED: string = "Multiple Account Sync Requested";
export const NAVIGATION_CLICKED: string = "Navigation Clicked";
export const SIGN_IN_LINK_CLICKED: string = "My Account:Account Creation;My Account:Login;Sign In";
export const CREATE_ACCOUNT_LINK_CLICKED: string = "My Account:Login;My Account:Account Creation;Create a New Account";
export const FORGET_PASSWORD_LINK_CLICKED: string = "My Account:Login;My Account:Password Forgotten;Forgot Password";
export const SIGN_IN_LABEL: string = "Sign In";
export const CREATE_ACCOUNT_LABEL: string = "Create a New Account";
export const FORGET_PASSWORD_LABEL: string = "Forgot Password";
export const LAST_ATTEMPT = "LastAttemptForSegment";
export const SITE_VCS = "vcs";
// https://segment.com/academy/collecting-data/naming-conventions-for-clean-data/
export const NOTIFICATION_MAP: any = {
  resetNotification: "User Reset-Password Notification Sent",
  resetFailed: "User Reset-Password Failed",
  sigInFailed: "User Sign-In Failed",
  sigUpFailed: "User Account Creation Failed",
  invalidFormSubmitted: "Invalid Form Submitted",
  callbackError: "Callback Error"
};

export const UNIFICATION_ERROR_MESSAGE: string = "We have found your profile in the sub brand identities. Please follow the instructions in the email to unify accounts.";

export const VISTAPRINT_ONLY_BRAND: string[] = ["vistaprint"];

export const EXPERIMENT_MAP = new Map<string, string[]>([
  ["vistaprint", ["en-BZ"]]
]);

export const EU_EXPERIMENT_MAP = new Map<string, string[]>([
  ["vistaprint", ["en-BZ", "en-GB"]]
]);
